module.exports = __webpack_public_path__ + "img/icon-search.68b9feb7.svg";